import { AppState } from './app.state';
import { ActionReducerMap } from '@ngrx/store';
import { userReducer } from './user/reducer';
import { appReducer } from './app/reducer';
import { MainStateInterface } from './main/main.model';
import { HomeStateInterface } from './home/home.model';
import { mainReducer } from './main/main.reducer';
import { homeReducer } from './home/home.reducer';
import { PageHeaderStateInterface } from './page-header/page-header.model';
import { pageHeaderReducer } from './page-header/page-header.reducer';
import { UserConfigurationStateInterface } from './user-configuration/user-configuration.model';
import { userConfigurationReducer } from './user-configuration/user-configuration.reducer';
import { deviceReducer } from './device/device.reducer';
import { DeviceStateInterface } from './device/device.model';
import { filterDeviceTypeReducer, FilterDeviceTypeState } from './filter/device-type/device-type.reducer';
import { deviceLastMessageReducer } from './device-last-message/device-last-message.reducer';
import { DeviceLastMessageStateInterface } from './device-last-message/device-last-message.model';
import { deviceCommandScheduleReducer } from './device-command-schedule/device-command-schedule.reducer';
import { DeviceCommandScheduleStateInterface } from './device-command-schedule/device-command-schedule.model';
import { firmwareManagerReducer } from './firmware-manager/firmware-manager.reducer';
import { FirmwareManagementStateInterface } from './firmware-manager/firmware-manager.model';
import { userManagementReducer } from './user-management/user-management.reducer';
import { UserManagementStateInterface } from './user-management/user-management.model';
import { DeviceParametersStateInterface } from './device-parameters/device-parameters.model';
import { deviceParametersReducer } from './device-parameters/device-parameters.reducer';
import { deviceDashboardReducer, DeviceDashboardState } from './device-dashboard/device-dashboard.reducer';

export interface FilterInterface {
  deviceTypeFilter: FilterDeviceTypeState;
}

export interface IotDeviceManagementPortalAppState extends AppState, FilterInterface {
  homeStore: HomeStateInterface;
  mainStore: MainStateInterface;
  pageHeaderStore: PageHeaderStateInterface;
  userConfigurationStore: UserConfigurationStateInterface;
  deviceStore: DeviceStateInterface;
  deviceDashboardStore: DeviceDashboardState;
  deviceLastMessageStore: DeviceLastMessageStateInterface;
  deviceParametersStore: DeviceParametersStateInterface;
  deviceCommandScheduleStore: DeviceCommandScheduleStateInterface;
  firmwareStore: FirmwareManagementStateInterface;
  userStore: UserManagementStateInterface;
}

export const iotDeviceManagementPortalAppReducer: ActionReducerMap<IotDeviceManagementPortalAppState> = {
  user: userReducer,
  app: appReducer,
  homeStore: homeReducer,
  mainStore: mainReducer,
  pageHeaderStore: pageHeaderReducer,
  userConfigurationStore: userConfigurationReducer,
  deviceStore: deviceReducer,
  deviceDashboardStore: deviceDashboardReducer,
  deviceLastMessageStore: deviceLastMessageReducer,
  deviceParametersStore: deviceParametersReducer,
  deviceCommandScheduleStore: deviceCommandScheduleReducer,
  deviceTypeFilter: filterDeviceTypeReducer,
  firmwareStore: firmwareManagerReducer,
  userStore: userManagementReducer,
};
